import { List, Map } from 'immutable'
import { footer, header, main, photoLibrary } from 'data/navigation'
import { useLanguage } from 'store/locale/hooks/useLanguage'

export interface IMenuItem {
  title: string
  description?: string
  imageUrl?: string
  link?: string
  isExternalLink?: boolean
  items?: IMenuItem[]
  columnType?: 'newsletterCol' | 'foundationCol'
  isSubMenu?: boolean
  isButton?: boolean
}

export enum MenuType {
  Main = 'main',
  Header = 'header',
  Footer = 'footer',
  PhotoLibrary = 'photo-library'
}

export const useMenu = (type: MenuType) => {
  const { language } = useLanguage()

  let menus = Map<MenuType, List<IMenuItem>>()
  menus = menus.set(MenuType.Footer, footer.get(language, List()))
  menus = menus.set(MenuType.Header, header.get(language, List()))
  menus = menus.set(MenuType.Main, main.get(language, List()))
  menus = menus.set(MenuType.PhotoLibrary, photoLibrary.get(language, List()))

  return menus.get(type, List<IMenuItem>())
}
